import Logo from "./Assets/logo.png";
import { ReactComponent as FacebookIcon } from "./Assets/facebook.svg";
import { ReactComponent as TwitterIcon } from "./Assets/twitter.svg";
import { ReactComponent as DiscordIcon } from "./Assets/discord.svg";
import { ReactComponent as InstagramIcon } from "./Assets/instagram.svg";
import { ReactComponent as YoutubeIcon } from "./Assets/youtube.svg";
import { ReactComponent as InnerAccordionArrow } from "./ChildComponents/BigCardsAccordion/Assets/arrowRight.svg";
import UserAvatar from "./Assets/avatar.png";
import SmallCardBackgroundImage from "./Assets/card.jpg";
import MaldivesBackgroundImage from "./Assets/big-card-1.jpg";
import EntertainmentBackgroundImage from "./Assets/entertainment-section.jpg";
import TrainingBackgroundImage from "./Assets/training-section.jpg";
import PrizesBackgroundImage from "./Assets/prizes-section.jpg";

export const BigCardsComponentMockData = [
  {
    bigCardbackgroundImage: MaldivesBackgroundImage,

    title: (
      <h1 className="title private-party font-pnb font-size-64 text-white lh-1">
        ZiXXarParadise <br /> <span>Private Party</span>
      </h1>
    ),

    subtitle: (
      <p className="font-pnm font-size-24 text-white">powered by UNTOLD</p>
    ),

    accordion: {
      accordionTagGradient:
        "linear-gradient(330deg, #48B2FD 13.39%, #9279FD 31.7%, #CB3FFF 50%, #F254BE 68.3%, #FABEBC 86.61%)",

      accordionTag: "Details",
      accordionItems: [
        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "0",
          headerText: "Included",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Thematic parties</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Fantastic music by UNTOLD DJs</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Drinks</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Guaranteed fun</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "1",
          headerText: "Day Party",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Beach party</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Refreshing drinks</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Dancing</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Tropical fun</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "2",
          headerText: "Night Party",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Party under the stars</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Chill atmosphere</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Tantalizing drinks</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Vibrant music</span>
              </div>
            </div>
          ),
        },
      ],
    },

    smallCard: {
      image: SmallCardBackgroundImage,
      backgroundGradient: "linear-gradient(180deg, #EDF 0%, #F8E8FF 100%)",
      name: (
        <>
          Bogdan <br />
          Radulescu
        </>
      ),
      profession: "CEO | Untold Festival",
      logo: Logo,
      userAvatar: UserAvatar,
      testimonial: "Adding web3 into our ecosystem was the best decision ever.",
      socialMediaLinks: [
        { icon: <FacebookIcon />, link: "" },
        { icon: <TwitterIcon />, link: "" },
        { icon: <DiscordIcon />, link: "" },
        { icon: <InstagramIcon />, link: "" },
        { icon: <YoutubeIcon />, link: "" },
      ],
      experience: [
        "CEO | Untold Festival",
        "CEO | Untold Festival",
        "CEO | Untold Festival",
      ],
      about: [
        "Brings extensive expertise to steer RHNA towards new horizons. He is dedicated to shaping RHNA as a catalyst for joyous celebrations worldwide.",
        "His strategic vision drives the development of a token ecosystem that not only empowers festival-goers but also brings communities closer to the artists they cherish.",
      ],
    },
  },

  {
    bigCardbackgroundImage: EntertainmentBackgroundImage,

    title: (
      <h1 className="title font-pnb font-size-64 lh-1 text-white">
        <span className="entertainment">Entertainment</span> <br /> Activities
      </h1>
    ),

    subtitle: (
      <p className="font-pnm font-size-24 text-white">powered by Sense4Fit</p>
    ),

    accordion: {
      accordionTagGradient:
        "linear-gradient(270deg, #00E0FF 0.1%, #CF0 99.08%)",

      accordionTag: "Details",
      accordionItems: [
        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "0",
          headerText: "Included",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Lifetime memories</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Activities led by qualified trainers
                </span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Friendly competitions between teams and individuals
                </span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Challenges varying in difficulty</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Games</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "1",
          headerText: "Sport Activities",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Trainer-led activities</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Different types of sports</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Workouts</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "2",
          headerText: "Team Competitions",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Trainer-led activities</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Friendly competition between ZiXXar teams
                </span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Various competitions types</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "3",
          headerText: "Individual Competitions",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Trainer-led activities</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Both tough and easy challenges</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Adrenaline-fueled activities</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "4",
          headerText: "Team Games",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Point-scored games</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Guaranteed fun</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">High-stakes atmosphere</span>
              </div>
            </div>
          ),
        },
      ],
    },

    smallCard: {
      image: SmallCardBackgroundImage,
      backgroundGradient: "linear-gradient(180deg, #EDF 0%, #F8E8FF 100%)",
      name: (
        <>
          Bogdan <br />
          Radulescu
        </>
      ),
      profession: "CEO | Untold Festival",
      logo: Logo,
      userAvatar: UserAvatar,
      testimonial: "Adding web3 into our ecosystem was the best decision ever.",
      socialMediaLinks: [
        { icon: <FacebookIcon />, link: "" },
        { icon: <TwitterIcon />, link: "" },
        { icon: <DiscordIcon />, link: "" },
        { icon: <InstagramIcon />, link: "" },
        { icon: <YoutubeIcon />, link: "" },
      ],
      experience: [
        "CEO | Untold Festival",
        "CEO | Untold Festival",
        "CEO | Untold Festival",
      ],
      about: [
        "Brings extensive expertise to steer RHNA towards new horizons. He is dedicated to shaping RHNA as a catalyst for joyous celebrations worldwide.",
        "His strategic vision drives the development of a token ecosystem that not only empowers festival-goers but also brings communities closer to the artists they cherish.",
      ],
    },
  },

  {
    bigCardbackgroundImage: TrainingBackgroundImage,

    title: (
      <h1 className="title font-pnb font-size-64 mb-0 text-white lh-1">
        <span className="training">Training</span> <br />
        Activities
      </h1>
    ),

    subtitle: (
      <p className="font-pnm font-size-24 text-white">powered by ZiXXar</p>
    ),

    accordion: {
      accordionTagGradient:
        "linear-gradient(330deg, #CF490C 13.39%, #FFA30F 50%, #FFF67A 86.61%)",

      accordionTag: "Details",
      accordionItems: [
        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "0",
          headerText: "Agenda",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
                <span>
                  Join us for transformative insights and practical strategies
                  to excel in your personal and professional endeavors. Engage
                  with expert presentations, interactive workshops, and
                  networking opportunities
                </span>

                <div className="d-flex text-start gap-1 align-items-center">
                  <InnerAccordionArrow />
                  <span className="ps-1">Expert presentations</span>
                </div>

                <div className="d-flex text-start gap-1 align-items-center">
                  <InnerAccordionArrow />
                  <span className="ps-1">Interactive workshops</span>
                </div>

                <div className="d-flex text-start gap-1 align-items-center">
                  <InnerAccordionArrow />
                  <span className="ps-1">Networking opportunities</span>
                </div>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "1",
          headerText: "Personal Development",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Discover your best self at ZiXXar Paradise's Personal
                Development sessions, where you'll be guided by professional
                trainers versed in transformative techniques and mindset shifts.{" "}
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Personal development sessions</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Professional trainers</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Transformative techniques</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "2",
          headerText: "Training Sales",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Master the art of sales at ZiXXar Paradise's Training Sales
                sessions. Learn cutting-edge tactics and ideas from seasoned
                professionals to succeed in the competitive sales field.
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Training sales sessions</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Cutting-edge sales tactics</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Ideas from seasoned professionals</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "3",
          headerText: "Training Marketing",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Come to ZiXXar Paradise's Training Marketing workshops to up
                your marketing game. Learn cutting-edge techniques and
                approaches from leaders in the field to increase your brand's
                impact and reach.
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Mastering the art of marketing</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Social Media tactics</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  How to work on your personal branding
                </span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "4",
          headerText: "Training Public Speaking",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Refine your public speaking prowess at ZiXXar Paradise's
                Training Public Speaking sessions. Led by seasoned orators,
                unlock the secrets to captivate audiences and confidently
                deliver impactful presentations.
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Unlock the secrets to captivate audiences
                </span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Refine your public dexterity</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />

                <span className="ps-1">
                  Gain confidence in delivering impactful presentations
                </span>
              </div>
            </div>
          ),
        },
      ],
    },

    smallCard: {
      image: SmallCardBackgroundImage,
      backgroundGradient: "linear-gradient(180deg, #EDF 0%, #F8E8FF 100%)",
      name: (
        <>
          Bogdan <br />
          Radulescu
        </>
      ),
      profession: "CEO | Untold Festival",
      logo: Logo,
      userAvatar: UserAvatar,
      testimonial: "Adding web3 into our ecosystem was the best decision ever.",
      socialMediaLinks: [
        { icon: <FacebookIcon />, link: "" },
        { icon: <TwitterIcon />, link: "" },
        { icon: <DiscordIcon />, link: "" },
        { icon: <InstagramIcon />, link: "" },
        { icon: <YoutubeIcon />, link: "" },
      ],
      experience: [
        "CEO | Untold Festival",
        "CEO | Untold Festival",
        "CEO | Untold Festival",
      ],
      about: [
        "Brings extensive expertise to steer RHNA towards new horizons. He is dedicated to shaping RHNA as a catalyst for joyous celebrations worldwide.",
        "His strategic vision drives the development of a token ecosystem that not only empowers festival-goers but also brings communities closer to the artists they cherish.",
      ],
    },
  },

  {
    bigCardbackgroundImage: PrizesBackgroundImage,

    title: (
      <h1 className="title rewards font-pnb font-size-64 private-party mb-0 lh-1">
        Rewards <br /> & Prizes
      </h1>
    ),

    subtitle: (
      <p className="font-pnm font-size-24 text-white">powered by ZiXXar</p>
    ),

    accordion: {
      accordionTagGradient:
        "linear-gradient(90deg, #00A7FF -11.89%, #842BD0 12.43%, #FF007E 38.9%, #FF474B 55.06%, #FF8023 72.56%, #FFA30A 81.92%, #FFB000 100%)",

      accordionTag: "Details",
      accordionItems: [
        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "0",
          headerText: "Token Airdrops",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Experience Token AirDrops at ZiXXar Paradise: seize digital
                treasures raining down, expand your crypto portfolio, and
                elevate your financial future in thrilling bursts of abundance!
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Experience Token AirDrops</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Expand your crypto portfolio</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Elevate your financial future</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "1",
          headerText: "NFTs AirDrops",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Take advantage of exclusive digital treasures and join the
                forefront of ownership by experiencing NFTs Drops at ZiXXar
                Paradise.
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Experience NFTs Drops</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Exclusive digital treasures</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Claim your stake</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "2",
          headerText: "Tokens & Special NFTs Rewards",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Discover Token & Special NFTs Rewards at ZiXXar Paradise to take
                advantage of one-of-a-kind digital assets and enhance your
                collection.
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Discover Token & Special NFTs Rewards
                </span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">One-of-a-kind digital assets</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Enhance your collection</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "3",
          headerText: "ZiXXar Trophy Rewards",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Celebrate greatness with ZiXXar Trophy Rewards: take home
                important awards and recognize exceptional accomplishments.
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Celebrate greatness with ZiXXar Trophy Rewards
                </span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Take home important awards</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Recognize exceptional accomplishments
                </span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "4",
          headerText: "Competitions Rewards",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Grab top prizes and demonstrate your abilities at our exciting
                events to win big with Competitions Rewards at ZiXXar Paradise!
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Competitions Rewards: Win big at exciting events
                </span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Grab top prizes</span>
              </div>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">Demonstrate your abilities</span>
              </div>
            </div>
          ),
        },

        {
          classNames: "px-5 pt-4 pb-3 pb-xl-4",
          eventKey: "5",
          headerText: " WispR Certificate",
          bodyText: (
            <div className="events-accordion__description w-100 text-md font-pnr d-flex flex-column">
              <span>
                Special ceremony to celebrate the WispR Shareholders with WispR
                Certificates.
              </span>

              <div className="d-flex text-start gap-1 align-items-center">
                <InnerAccordionArrow />
                <span className="ps-1">
                  Special ceremony for Wispr Shareholders with WispR
                  Certificates.
                </span>
              </div>
            </div>
          ),
        },
      ],
    },

    smallCard: {
      image: SmallCardBackgroundImage,
      backgroundGradient: "linear-gradient(180deg, #EDF 0%, #F8E8FF 100%)",
      name: (
        <>
          Bogdan <br />
          Radulescu
        </>
      ),
      profession: "CEO | Untold Festival",
      logo: Logo,
      userAvatar: UserAvatar,
      testimonial: "Adding web3 into our ecosystem was the best decision ever.",
      socialMediaLinks: [
        { icon: <FacebookIcon />, link: "" },
        { icon: <TwitterIcon />, link: "" },
        { icon: <DiscordIcon />, link: "" },
        { icon: <InstagramIcon />, link: "" },
        { icon: <YoutubeIcon />, link: "" },
      ],
      experience: [
        "CEO | Untold Festival",
        "CEO | Untold Festival",
        "CEO | Untold Festival",
      ],
      about: [
        "Brings extensive expertise to steer RHNA towards new horizons. He is dedicated to shaping RHNA as a catalyst for joyous celebrations worldwide.",
        "His strategic vision drives the development of a token ecosystem that not only empowers festival-goers but also brings communities closer to the artists they cherish.",
      ],
    },
  },
];
